module.exports = __webpack_public_path__ + "b41bfcf37a8a365d2c101c9931bc0e75.gif";